<div [className]="currentOrder === null && !showSearch ? '' : 'd-none'">
  <nav class="navbar navbar-light bg-light mt-2">
    <form class="w-100">
      <!--

      Extra filters: Currently deactivated

      <div class="form-row">
        <div id="fromDateContainer" class="form-group col-md-4">
          <label for="fromDate">From</label>
          <input id="fromDate" name="fromDate" type="text"
                 class="form-control theme-default mouse-pointer"
                 readonly
                 bsDatepicker
                 (bsValueChange)="applyDateRange($event)"
                 (input)="filterObject.fromDate = $event.target.value"
                 [(bsValue)]="filterObject.fromDate"
                 [value]="filterObject.fromDate | date: 'dd/MM/yyyy'"
                 [bsConfig]="{
                  orientation: 'bottom',
                  adaptivePosition: true,
                  container: '#fromDateContainer',
                  autoclose: true,
                  dateInputFormat: 'DD/MM/YYYY',
                  todayHighlight: true,
                  maxDate: today
               }"
          >
        </div>
        <div id="untilDateContainer" class="form-group col-md-4">
          <label for="untilDate">Until</label>
          <input id="untilDate" name="untilDate" type="text"
                 class="form-control theme-default mouse-pointer"
                 readonly
                 bsDatepicker
                 (bsValueChange)="applyDateRange($event)"
                 (input)="filterObject.untilDate = $event.target.value"
                 [(bsValue)]="filterObject.untilDate"
                 [value]="filterObject.untilDate | date: 'dd/MM/yyyy'"
                 [bsConfig]="{
                  orientation: 'bottom',
                  adaptivePosition: false,
                  container: '#untilDateContainer',
                  autoclose: true,
                  dateInputFormat: 'DD/MM/YYYY',
                  todayHighlight: true,
                  maxDate: today
               }"
          >
        </div>
        <div class="form-group col-md-4">
          <label for="productTypes">Product</label>
          <select id="productTypes" class="form-control"
                  (change)="applyFilter($event)"
                  [value]="filterObject.productTypeId"
                  (input)="filterObject.productTypeId = +$event.target.value"
          >
            <option value="0">
              {{i18n.get('global_all_label')}}
            </option>
            <ng-container *ngFor="let item of productTypes">
              <option value="{{item.id}}">
                {{item.label}}
              </option>
            </ng-container>
          </select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="users">Users</label>
          <select id="users" class="form-control"
                  (change)="applyFilter($event)"
                  [value]="filterObject.userId"
                  (input)="filterObject.userId = +$event.target.value"
          >
            <option value="0">
              {{i18n.get('global_all_label')}}
            </option>
            <ng-container *ngFor="let item of users">
              <option value="{{item.id}}">
                {{item.label}}
              </option>
            </ng-container>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="countries">Markets</label>
          <select id="countries" class="form-control"
                  (change)="applyFilter($event)"
                  [value]="filterObject.marketId"
                  (input)="filterObject.marketId = +$event.target.value"
          >
            <option value="0">
              {{i18n.get('global_all_label')}}
            </option>
            <ng-container *ngFor="let item of markets">
              <option value="{{item.id}}">
                {{item.label}}
              </option>
            </ng-container>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="companies">Companies</label>
          <select id="companies" class="form-control"
                  (change)="applyFilter($event)"
                  [value]="filterObject.companyId"
                  (input)="filterObject.companyId = +$event.target.value"
          >
            <option value="0">
              {{i18n.get('global_all_label')}}
            </option>
            <ng-container *ngFor="let item of companies">
              <option value="{{item.id}}">
                {{item.label}}
              </option>
            </ng-container>
          </select>
        </div>
      </div>
      -->
      <div class="form-row">
        <div class="p-3 pb-0 col-12">
          <label for="filter">{{i18n.get('global_search_label')}}</label>
          <input id="filter" (keyup)="applyFilter($event)" [value]="filterObject.filtervalue"
                 (search)="applyFilter($event)"
                 (input)="filterObject.filtervalue = $event.target.value"
                 class="form-control" type="search" placeholder="{{i18n.get('orders_search_placeholder', 'orders')}}"
                 aria-label="Search">
          <div class="text-end text-muted mt-2 me-1">
            <a class="mouse-pointer" (click)="openSearch()">
              <i class="fas fa-search"></i> {{i18n.get('orders_advanced_search', 'orders')}}
            </a>
          </div>
        </div>
      </div>
    </form>
  </nav>

  <table mat-table matTableExporter matSort [dataSource]="datalistsource" #exporter="matTableExporter">

    <ng-container *ngFor="let column of displayedColumns">

      <ng-container matColumnDef="{{column}}">
        <th mat-header-cell mat-sort-header [disabled]="column === 'actions' || column === 'status'"
            class="pl-2 pr-2 text-capitalize" *matHeaderCellDef>{{getColumnLabel(column)}}</th>
        <td mat-cell *matCellDef="let element">
          <div class="ms-2 me-2">
            <ng-container *ngIf="column !== 'actions'">
              <ng-container *ngIf="column !== 'user_company'">
                {{getFormattedValue(column, element[column])}}
              </ng-container>
              <ng-container *ngIf="column === 'user_company'">
                <strong>{{element['company_label']}}</strong>
                <br/>
                {{element['userFullName']}}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="column === 'actions'">
              <div class="btn-group">
                <button class="btn" (click)="renewOrder(element)" title="{{i18n.get('orders_renew_label', 'orders')}}">
                  <i class="fas fa-redo"></i></button>
                <button class="btn" (click)="openDetails(element)" title="{{i18n.get('global_details_label')}}"><i
                  class="fas fa-info-circle"></i></button>
              </div>
            </ng-container>
          </div>
        </td>
      </ng-container>

    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>


  <div *ngIf="!datalistsource" class="alert text-center mt-1" role="alert">
    <i class="fa-spin fas fa-sync me-2"></i>{{i18n.get('orders_loading_last_aos_orders', 'orders')}}
  </div>

  <div class="mb-5 btn-toolbar justify-content-between mt-2">
    <div>
      <mat-paginator [pageSizeOptions]="[20, 100, 500]" showFirstLastButtons></mat-paginator>
    </div>
    <div class="btn-group" *ngIf="datalistsource && datalistsource.data.length > 0">
      <button (click)="exporter.exportTable('csv', exportOptions)" type="button"
              class="btn btn-sm btn-outline-secondary"><i class="fas fa-file-csv me-2"></i>
        {{i18n.get('orders_export_csv_label', 'orders')}}
      </button>
      <button (click)="exporter.exportTable('xls', exportOptions)" type="button" class="btn btn-sm btn-outline-primary">
        <i class="fas fa-file-excel me-2"></i>
        {{i18n.get('orders_export_excel_label', 'orders')}}
      </button>
    </div>
  </div>
</div>

<!-- Search -->
<ng-container *ngIf="showSearch">
  <app-aos-order-search (onClose)="closeSearch()"></app-aos-order-search>
</ng-container>

<!-- Order details -->
<ng-container *ngIf="currentOrder">
  <div class="container">
    <div class="row">
      <div class="col bg-white details-wrapper my-3 pt-3">
        <button class="btn btn-sm btn-light float-end d-lg-block"
                (click)="closeDetails()">{{i18n.get('global_back_to_list_label')}}</button>
        <app-aos-order-details [order]="currentOrder"></app-aos-order-details>
      </div>
    </div>
  </div>
</ng-container>
